const STRINGS = {
  closeButtonAriaLabel: "hide full content",
  showFullContentAriaLabel: "show full content",
  fullContentShownLiveRegion: "full content shown",
  fullContentHiddenLiveRegion: "full content hidden"
};
export default STRINGS;